import { useEffect } from "react";
import { useLocation } from "wouter";

export default function ScrollToTop() {
    const [pathname] = useLocation();

    useEffect(() => {
        const handleScroll = () => {
            if (window.location.hash) {
                const id = window.location.hash.substring(1);
                // Delay scroll to allow lazy components to possibly render
                setTimeout(() => {
                    const element = document.getElementById(id);
                    if (element) {
                        element.scrollIntoView({ behavior: 'smooth' });
                    }
                }, 400);
            } else {
                window.scrollTo(0, 0);
            }
        };

        handleScroll();
    }, [pathname]);

    return null;
}
